// extracted by mini-css-extract-plugin
export var label = "_dx-2";
export var slideContainer = "_dx-0";
export var slider = "_dx-1";